import React, {Component} from 'react';
import Autosuggest from 'react-autosuggest';
import { Field } from 'formik';
import { isFieldValidClass } from "~/js/utils";

class AutoCompleteTextBox extends Component {
    state = {
        value: '',
        suggestions: [],
        isFocused: false,
        hasChanged: false,
    };

    getSuggestions = value => {
        const { options} = this.props;
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;
        return inputLength === 0 ? [] : options.filter(op =>
            op.label.toLowerCase().slice(0, inputLength) === inputValue && op.label.toLowerCase() != 'select model' && op.label.toLowerCase() != 'select make' && op.label.toLowerCase() != 'select brand'
        );
    };

    handleFocus = () => {
        const { form, name} = this.props;
        form.setFieldTouched(name, true);
        this.setState({ isFocused: true });

    }

    handleBlur = (e) => {
        const { form, name} = this.props;

        if (form) {
            form.setFieldTouched(name, true);
            form.handleBlur(e);
        }
        this.setState({ isFocused: false });
    };
    componentDidMount() {
        const { options, placeholder, form, name } = this.props;

    }

    handleChange = (selectedOption) => {
        const { onChange, form, name } = this.props;

        this.setState({ selectedOption });

        if (onChange) onChange(selectedOption);

        // If using Formik
        if (form) {
            // Hook to update form value
            const value = selectedOption ? selectedOption.value : null;
            form.setFieldValue(name, value);
        }
        this.setState({ hasChanged: true });

    };

    getSuggestionValue = suggestion => suggestion.label;


    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: this.getSuggestions(value)
        });
    }
    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };
    renderSuggestion = (suggestion) => {return (
        <div className={'mt-3 mb-3'}>
            {suggestion.label}
        </div>
    );}
    onChange = (event, { newValue }) => {
        const { onChange, form, name } = this.props;

        this.setState({ newValue });

        if (onChange) onChange(newValue);
        if(form){
            form.setFieldValue(name, newValue);
        }

        this.setState({
            value: newValue
        });
    };
    render() {
        const { value, suggestions, isFocused, hasChanged } = this.state;
        const { name, form, placeholder, ...rest } = this.props;

        const inputProps = {
            placeholder: placeholder,
            value,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onChange: this.onChange
        };
        let className = "input input--form";

        if (form) className += ` ${isFieldValidClass(name, form)}`;
        if (isFocused) className += ` is-focused`;
        if (hasChanged) className += ` has-changed`;

        return (
            <div className={className}>
                <div className="input__field">
                    <Autosuggest
                        name={name}
                        suggestions={suggestions}
                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                        getSuggestionValue={this.getSuggestionValue}
                        renderSuggestion={this.renderSuggestion}
                        inputProps={inputProps}
                    />
                </div>
            </div>
        );
    }
}

export { AutoCompleteTextBox };
